import React from 'react';
import { Input, Textarea } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { SIMPLE_TYPES, MAIN_PLACEHOLDERS } from '../data/qrRegistry';

const QrMainInput = observer(({ store }) => {
  const type = store.qrType;
  if (!type || !SIMPLE_TYPES.includes(type.id)) return null;

  const fieldId = type.primaryFieldId || type.fields[0]?.id;
  const field = type.fields.find((f) => f.id === fieldId);
  if (!field) return null;

  const value = store.formData[fieldId] ?? '';
  const placeholder = MAIN_PLACEHOLDERS[type.id] || field.placeholder;
  const setValue = (v) => store.setFormData(fieldId, v);

  const isMultiline = field.type === 'textarea' || type.id === 'text';

  return isMultiline ? (
    <Textarea
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder}
      size="lg"
      borderRadius="xl"
      rows={3}
      fontSize="md"
      _placeholder={{ color: 'gray.400' }}
      autoFocus
    />
  ) : (
    <Input
      type={field.type === 'url' ? 'url' : field.type === 'email' ? 'email' : field.type === 'tel' ? 'tel' : 'text'}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder}
      size="lg"
      borderRadius="xl"
      fontSize="md"
      _placeholder={{ color: 'gray.400' }}
      autoFocus
    />
  );
});

export default QrMainInput;
